import imageValidator from 'app/validators/activities/create/sync/image'
import {
  createValidator,
  isRequired,
  stringLength,
  combineValidators,
  notInArray,
  constants,
  isUrl,
  safeTrim,
  createSyncValidator,
} from 'app/validators/base'

export const validateImage = combineValidators(
  [
    isRequired(value => (typeof value === 'string' ? value.trim() : value)),
    notInArray([constants.IMAGE_TOO_SMALL, constants.WRONG_FILE_TYPE], value => value, {
      [constants.IMAGE_TOO_SMALL]: 'too small',
      [constants.WRONG_FILE_TYPE]: 'wrong type, file should be an image (.png, .jpg, .jpeg)',
    }),
    isUrl(value => value),
  ],
  true
)

const syncValidate = createSyncValidator(
  {
    field: 'image',
    validator: imageValidator,
  },
  {
    field: 'title',
    validator: createValidator(stringLength({ min: 5, max: 42 }, safeTrim), 'title'),
  },
  {
    field: 'subTitle',
    validator: createValidator(stringLength({ min: 5, max: 620 }, safeTrim), 'subTitle'),
  },
  {
    field: 'formTitle',
    validator: createValidator(stringLength({ min: 5, max: 50 }, safeTrim), 'formTitle'),
  },
  {
    field: 'formSubTitle',
    validator: createValidator(stringLength({ min: 5, max: 64 }, safeTrim), 'formSubTitle'),
  }
)

const syncValidate_v2 = createSyncValidator(
  {
    field: 'mainBackground_v2',
    validator: createValidator(validateImage, 'mainBackground_v2'),
  },
  {
    field: 'proQuoteAuthorImage_v2',
    validator: createValidator(validateImage, 'proQuoteAuthorImage_v2'),
  },
  {
    field: 'platformAboutImage_v2',
    validator: createValidator(validateImage, 'platformAboutImage_v2'),
  },
  {
    field: 'fourthBoxImage_v2',
    validator: createValidator(validateImage, 'fourthBoxImage_v2'),
  },
  {
    field: 'thirdBoxImage_v2',
    validator: createValidator(validateImage, 'thirdBoxImage_v2'),
  },
  {
    field: 'secondBoxImage_v2',
    validator: createValidator(validateImage, 'secondBoxImage_v2'),
  },
  {
    field: 'firstBoxImage_v2',
    validator: createValidator(validateImage, 'firstBoxImage_v2'),
  },
  {
    field: 'welcomeText_v2',
    validator: createValidator(stringLength({ min: 5, max: 40 }, safeTrim), 'welcomeText_v2'),
  },
  {
    field: 'title_v2',
    validator: createValidator(stringLength({ min: 5, max: 46 }, safeTrim), 'title_v2'),
  },
  {
    field: 'subTitle_v2',
    validator: createValidator(stringLength({ min: 5, max: 420 }, safeTrim), 'subTitle_v2'),
  },

  {
    field: 'formTitle_v2',
    validator: createValidator(stringLength({ min: 5, max: 50 }, safeTrim), 'formTitle_v2'),
  },
  {
    field: 'formSubTitle_v2',
    validator: createValidator(stringLength({ min: 5, max: 64 }, safeTrim), 'formSubTitle_v2'),
  },
  {
    field: 'quote_v2',
    validator: createValidator(stringLength({ min: 5, max: 205 }, safeTrim), 'quote_v2'),
  },
  {
    field: 'quoteAuthor_v2',
    validator: createValidator(stringLength({ min: 5, max: 80 }, safeTrim), 'quoteAuthor_v2'),
  },
  {
    field: 'secondTitle_v2',
    validator: createValidator(stringLength({ min: 5, max: 56 }, safeTrim), 'secondTitle_v2'),
  },
  {
    field: 'secondSubTitle_v2',
    validator: createValidator(stringLength({ min: 5, max: 450 }, safeTrim), 'secondSubTitle_v2'),
  },
  {
    field: 'textBoxesHeader_v2',
    validator: createValidator(stringLength({ min: 5, max: 56 }, safeTrim), 'textBoxesHeader_v2'),
  },
  {
    field: 'firstBoxTitle_v2',
    validator: createValidator(stringLength({ min: 5, max: 30 }, safeTrim), 'firstBoxTitle_v2'),
  },
  {
    field: 'firstBoxSubTitle_v2',
    validator: createValidator(stringLength({ min: 5, max: 80 }, safeTrim), 'firstBoxSubTitle_v2'),
  },
  {
    field: 'secondBoxTitle_v2',
    validator: createValidator(stringLength({ min: 5, max: 30 }, safeTrim), 'secondBoxTitle_v2'),
  },
  {
    field: 'secondBoxSubTitle_v2',
    validator: createValidator(stringLength({ min: 5, max: 80 }, safeTrim), 'secondBoxSubTitle_v2'),
  },
  {
    field: 'thirdBoxTitle_v2',
    validator: createValidator(stringLength({ min: 5, max: 30 }, safeTrim), 'thirdBoxTitle_v2'),
  },
  {
    field: 'thirdBoxSubTitle_v2',
    validator: createValidator(stringLength({ min: 5, max: 80 }, safeTrim), 'thirdBoxSubTitle_v2'),
  },
  {
    field: 'fourthBoxTitle_v2',
    validator: createValidator(stringLength({ min: 5, max: 30 }, safeTrim), 'fourthBoxTitle_v2'),
  },
  {
    field: 'fourthBoxSubTitle_v2',
    validator: createValidator(stringLength({ min: 5, max: 80 }, safeTrim), 'fourthBoxSubTitle_v2'),
  },
  {
    field: 'quoteAuthorAbout_v2',
    validator: createValidator(stringLength({ min: 5, max: 60 }, safeTrim), 'quoteAuthorAbout_v2'),
  }
)

export { syncValidate, syncValidate_v2 }
